import * as styles from "./AbsenceIdentity.css";

import { clsx } from "clsx";
import { useAtomValue } from "jotai";

import { Avatar } from "@frontend/components/atoms/Avatar";
import {
  Meter,
  MeterIndicator,
  MeterTrack,
  MeterValue,
} from "@frontend/components/atoms/Meter";
import { Skeleton } from "@frontend/components/atoms/Skeleton";
import { Trans } from "@lingui/react/macro";

import {
  balanceAtom,
  balanceLoadingAtom,
  employeeAvatarUrlAtom,
  employeeIdAtom,
  employeeNameAtom,
} from "../stores";
import { initials } from "../utils/format";

export function AbsenceIdentity() {
  const employeeId = useAtomValue(employeeIdAtom);
  const employeeName = useAtomValue(employeeNameAtom);
  const avatarUrl = useAtomValue(employeeAvatarUrlAtom);
  const balance = useAtomValue(balanceAtom);
  const balanceLoading = useAtomValue(balanceLoadingAtom);

  const over = balance ? balance.remainingDays < 0 : false;

  return (
    <div className={styles.identity}>
      <Avatar
        className={styles.avatar}
        url={avatarUrl ?? undefined}
        fallback={initials(employeeName)}
        size="md"
      />

      <span className={styles.names}>
        <span className={styles.name}>{employeeName}</span>

        <span className={styles.balance}>
          <span className={styles.meta}>
            <Trans>Employee {employeeId}</Trans>
          </span>

          {balanceLoading && <Skeleton className={styles.balanceSkeleton} />}

          {balance && (
            <>
              <span className={styles.meta}>
                <Trans>Balance {balance.year}</Trans>
              </span>

              <span className={over ? styles.negative : styles.positive}>
                <Trans>{balance.remainingDays} days</Trans>
              </span>
            </>
          )}

          {balance && !balance.settled && balance.dueDays > 0 && (
            <Meter
              className={clsx(styles.meter, over && styles.over)}
              value={balance.takenDays}
              max={balance.dueDays}
            >
              <MeterTrack>
                <MeterIndicator />
              </MeterTrack>

              <MeterValue className={styles.meterValue}>
                {() => `${balance.dueDays} owed / ${balance.takenDays} taken`}
              </MeterValue>
            </Meter>
          )}
        </span>
      </span>
    </div>
  );
}
